import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { APIService } from 'src/app/API.service';
import { environment } from 'src/environments/environment';
import { AdminService } from '../../services/admin.service';
import { EditUserDialogComponent } from '../edit-user-dialog/edit-user-dialog.component';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  constructor(
    private router: Router, 
    private admin: AdminService,
    private dialog: MatDialog,
    private api: APIService,
    private snackbar: MatSnackBar
  ) { }

  loadingUsers: boolean;
  loadingModules: boolean;

  allUsers : MatTableDataSource<User> = new MatTableDataSource([])

  async ngOnInit() {
    this.reload(); 
  }

  async reload() {

    this.loadingUsers = true;

    await this.admin.getAllUsers().then(results => {

      this.allUsers.data = results.map(u => {

        var userId = u.Attributes.filter(a => a.Name == "sub")[0].Value
        var email = u.Attributes.filter(a => a.Name == "email")[0].Value
        var rpmAvatarURL = u.Attributes.filter(a => a.Name == "custom:RPMAvatarURL")[0]?.Value || ""

        return {
          id: userId,
          username: u.Username,
          email: email,
          isAdmin: false,
          isAnon: false,
          rpmAvatarURL: rpmAvatarURL
        }

      }).filter(u => !u.isAnon)

    })

    this.sortUsersByName();

    this.loadingUsers = false;

  }

  addUser() {
    this.router.navigate(['userAdd'])
  }

  viewUser(userId) {
    this.router.navigate(['user', userId])
  }

  async editUser(user: User) {

    this.dialog.open(EditUserDialogComponent, {
      data: {rpmAvatarURL: user.rpmAvatarURL},
      width: "40vw"
    }).afterClosed().subscribe(result => {

      if (result == undefined) return;

      var saved = user.rpmAvatarURL

      user.rpmAvatarURL = null
      
      this.api.UpdateRpmAvatarUrl(user.username, result).then((success) => {
        if (success) {
          user.rpmAvatarURL = result
          this.snackbar.open("Avatar URL for '" + user.username + "' has been updated", "OK")
        } else {
          user.rpmAvatarURL = saved;
          this.snackbar.open("An unexpected error occurred", "OK")
        }
      })

    })

  }

  sortUsers(event) {

    switch(event.active) {
      case "username":
        this.sortUsersByName(event.direction)
        break;
      case "email":
        this.sortUsersByEmail(event.direction)
        break;
      case "isAdmin":
        this.sortUsersByAdmin(event.direction)
        break;
      case "rpmAvatarURL":
        this.sortUsersByRPMAvatarURL(event.direction)
        break;
    }

  }

  sortUsersByName(direction: string = "asc") {
    this.allUsers.data = this.allUsers.data.sort((a, b) => (direction != "desc") ? a.username.localeCompare(b.username) : b.username.localeCompare(a.username))
  }

  sortUsersByEmail(direction: string = "asc") {
    this.allUsers.data = this.allUsers.data.sort((a, b) => (direction != "desc") ? a.email.localeCompare(b.email) : b.email.localeCompare(a.email));
  }

  sortUsersByAdmin(direction: string = "asc") {
    this.allUsers.data = this.allUsers.data.sort((a, b) => a.isAdmin == b.isAdmin ? 0 : ((a.isAdmin ? -1 : 1) * (direction != "desc" ? 1 : -1)));
  }

  sortUsersByRPMAvatarURL(direction: string = "asc") {
    this.allUsers.data = this.allUsers.data.sort((a, b) => (direction != "desc") ? a.rpmAvatarURL.localeCompare(b.rpmAvatarURL) : b.rpmAvatarURL.localeCompare(a.rpmAvatarURL));
  }

}

type User = {
  id: string,
  username: string,
  email: string,
  isAdmin: boolean,
  isAnon: boolean,
  rpmAvatarURL: string
}